import gql from 'graphql-tag';
import Client from "../services/Client";
import Cookie from "../services/Cookie";


const ExamAction = {
    /**
     * @purpose: get course and examType wise exam list
     * @author: Arijit Deb Roy
     * @return:
     */
    examList(courseId, examType, examStatus, status, offset, limit) {
        const EXAM_LIST = gql`
                query listExam($token: AccessToken!, $input: ExamListInput!) {
                  listExam(token: $token, input: $input) {
                    code
                    status
                    message
                    data {
                      exams {
                        examId
                        instructionId
                        courseId
                        examType
                        examSubType
                        examTitle
                        examDescription
                        examStatus
                        otherDetails
                        createdAt
                        updatedAt
                        updatedBy
                        createdBy
                        totalQuestion
                        totalTime
                        totalBreakTime
                        paidStatus
                      }
                     totalCount
                    }
                  }
                }
            `;
        return Client.query({
            query: EXAM_LIST,
            variables: {
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                },
                input: {
                    input: {
                        filters: {
                            courseId: courseId,
                            examType: examType,
                            examStatus: examStatus
                        },
                        pagination: {
                            status: status,
                            limit: limit,
                            offset: offset
                        }
                    }
                }
            }
        });
    },

    /**
     * @purpose: get course wise exam with instruction
     * @author: Arijit Deb Roy
     * @return:
     */
    examTypes(courseId) {
        const EXAM_TYPES = gql`
                query typesExam($token: AccessToken!, $input: ExamTypeInput!) {
                  typesExam(token: $token, input: $input) {
                    code
                    status
                    message
                    data {
                      exams {
                        examType
                        draft
                        active
                        inactive
                        archive
                        published
                        needsReview
                      }
                      instructions {
                        instructionTitle
                        instructionId
                        examType
                        instructionStatus
                      }
                    }
                  }
                }
            `;
        return Client.query({
            query: EXAM_TYPES,
            variables: {
                token: {
                    accessToken: null,
                    accessRole: null
                },
                input: {
                    courseId: courseId
                }
            }
        });
    },

    /**
     * @purpose: get exam configuration
     * @author: Arijit Deb Roy
     * @return:
     */
    examDetails(courseId, examId) {
        const DETAIL_EXAM = gql`
                            query examDetails($token: AccessToken!, $input: ExamDetailsInput!) {
                              examDetails(token: $token, input: $input) {
                                code
                                status
                                message
                                data {
                                  basicConfig{
                                    courseId
                                    examId
                                    examType
                                    examTitle
                                    examDescription
                                    examStatus
                                    instructionId
                                    instructionTitle
                                    instruction
                                    totalQuestion
                                    totalTime
                                    totalCap
                                    paid
                                    otherDetails
                                    createdBy
                                    minScore
                                    maxScore
                                    totalUserCount
                                    uniqueUserCount
                                  }
                                  weeklyConfig{
                                    weeklyExamDateId
                                    examId
                                    startDate
                                    endDate
                                    status
                                    createdBy
                                  }
                                  fullMockConfig{
                                    mockSectionTimeId
                                    examId
                                    sectionId
                                    sectionName
                                    sectionInstruction
                                    sectionFile
                                    sectionFilePath
                                    sectionTotalQuestion
                                    sectionTotalDuration
                                    break
                                    weight
                                    status
                                    createdBy
                                  }
                                }
                              }
                            }
                           `;
        return Client.query({
            query: DETAIL_EXAM,
            variables: {
                input: {
                    courseId: courseId,
                    examId: examId,
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                },
            }
        });
    },

    /**
     * @purpose: get section wise questions
     * @author: Arijit Deb Roy
     * @return:
     */
    examQuestionSectionDetails(courseId, examId) {
        const EXAM_TYPES = gql`
                    query examQuesDetails($token: AccessToken!, $input: ExamQuesDetailsInput!) {
                      examQuesDetails(token: $token, input: $input) {
                        code
                        status
                        message
                        data{
                          id
                          courseId
                          instructionId
                          examTitle
                          examType
                          examStatus
                          totalQuestion
                          totalTime
                          totalCap
                          paid
                          minScore
                          maxScore
                          sections{
                            sectionId
                            sectionName
                            mockSectionTimeId
                            sectionTotalQuestion
                            sectionTotalDuration
                            sectionWeight
                            sectionStatus
                            questionList{
                              questionId
                              id
                              weight
                              status
                              examQuestionGroupId
                              questionType
                              questionOrder
                              questionTitle
                              questionLevel
                              questionStatus
                              isNumeric
                              correctAns
                              topicId
							                referenceId
                              highlightPassageFlag
                              topicName
                            }
                          }
                        }
                      }
                    }
                `;
        return Client.query({
            query: EXAM_TYPES,
            variables: {
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                },
                input: {
                    courseId: courseId,
                    examId: examId
                }
            }
        });
    },

    /**
     * Fetch Questions Before | After Exam
     * @author: Arijit Deb Roy
     * @params: inputObj: <Object> {userId: <Integer>,userExamId: <Integer>,examType: <String>,questionIds: <Array>[Array of integer]}
     */
    examQuestionsBeforeAfter(inputObj) {
        const FETCH_QUESTION_BEFORE_AFTER = gql`
          query fetchExamQuestionsBeforeAfter($token: AccessToken!,$input: ExamQuestionsBeforeAfterInput!){
            fetchExamQuestionsBeforeAfter(token: $token, input: $input){
              code
              status
              message
              data{
                totalCount
                questions{
                  questionId
                  courseId
                  sectionId
                  questionTitle
                  titleVisibility
                  questionLevel
                  questionType
                  questionFile
                  questionFilePath
                  passageFilePath
                  passageFileType
                  timeTaken
                  isNumeric
                  correctAns
                  ansFile
                  ansFilePath
                  ansFileType
                  ansDescription
                  questionWeight
                  topicId
                  questionStatus
                  passageId
                  passageTitle
                  passage
                  userPassageId
                  userId
                  userHighlightPassage
                  highlightPassageId
                  highlightPassage
                  highlightPassageFlag
                  createdBy
                  updatedBy
                  createdAt
                  updatedAt
                  questionOptions{
                    questionOptionId
                    questionId
                    questionOption
                    questionOptionValue
                    questionOptionFile
                    questionOptionFilePath
                    questionOptionFileType
                    questionOptionDescription
                    questionOptionWeight
                  }
                  userExamQuestionId
                  correctStatus
                  userMockSectionId
                }
              }
            }
          }`;
        return Client.query({
            query: FETCH_QUESTION_BEFORE_AFTER,
            variables: {
                input: {
                    filters: {
                        userId: inputObj.userId,
                        userExamId: inputObj.userExamId,
                        examType: inputObj.examType,
                        questionIds: inputObj.questionIds
                    },
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * Fetch Questions sorted and filtered exept worksheet
     * @author: Arijit Deb Roy
     * @params: inputObj: <Object> {userId: <Integer>, examId: <Integer>, sectionId: <Integer>}
     */
    examQuestions(inputObj) {
        const FETCH_QUESTIONS = gql`
        query fetchExamQuestions($token: AccessToken!,$input: ExamQuestionsInput!){
          fetchExamQuestions(token: $token, input: $input){
            code
            status
            message
            data{
              totalCount
              questions{
                questionId
                courseId
                sectionId
                questionTitle
                titleVisibility
                questionLevel
                questionType
                questionFile
                questionFilePath
                passageFilePath
                passageFileType
                timeTaken
                isNumeric
                correctAns
                ansFile
                ansFilePath
                ansFileType
                ansDescription
                questionWeight
                topicId
                questionStatus
                passageId
                passageTitle
                passage
                userPassageId
                userId
                userHighlightPassage
                highlightPassageId
                highlightPassage
                highlightPassageFlag
                createdBy
                updatedBy
                createdAt
                updatedAt
                questionOptions{
                  questionOptionId
                  questionId
                  questionOption
                  questionOptionValue
                  questionOptionFile
                  questionOptionFilePath
                  questionOptionFileType
                  questionOptionDescription
                  questionOptionWeight
                }
                userExamQuestionId
                correctStatus
                userMockSectionId
                strike
                review
                questionOrder
                sectionName
                topicName
              }
            }
          }
        }`;
        return Client.query({
            query: FETCH_QUESTIONS,
            variables: {
                input: {
                    filters: {
                        userId: inputObj.userId,
                        examId: inputObj.examId,
                        sectionId: inputObj.sectionId,
                        mockSectionTimeId: inputObj.mockSectionTimeId,
                        userExamId: inputObj.userExamId,
                    },
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * Fetch Questions sorted and filtered exept worksheet
     * @author: Arijit Deb Roy
     * @params: inputObj: <Object> {userId: <Integer>, worksheetId: <Integer>}
     */
    worksheetExamQuestions(inputObj) {
        const FETCH_QUESTIONS = gql`
      query fetchWorksheetExamQuestions($token: AccessToken!,$input: ExamQuestionsInput!){
        fetchWorksheetExamQuestions(token: $token, input: $input){
          code
          status
          message
          data{
            totalCount
            questions{
              questionId
              courseId
              sectionId
              questionTitle
              titleVisibility
              questionLevel
              questionType
              questionFile
              questionFilePath
              passageFilePath
              passageFileType
              timeTaken
              isNumeric
              correctAns
              ansFile
              ansFilePath
              ansFileType
              ansDescription
              questionWeight
              topicId
              questionStatus
              passageId
              passageTitle
              passage
              userPassageId
              userId
              userHighlightPassage
              highlightPassageId
              highlightPassage
              highlightPassageFlag
              createdBy
              updatedBy
              createdAt
              updatedAt
              questionOptions{
                questionOptionId
                questionId
                questionOption
                questionOptionValue
                questionOptionFile
                questionOptionFilePath
                questionOptionFileType
                questionOptionDescription
                questionOptionWeight
              }
              userExamQuestionId
              correctStatus
              userMockSectionId
              strike
              review
              questionOrder
              sectionName
              topicName
            }
          }
        }
      }`;
        return Client.query({
            query: FETCH_QUESTIONS,
            variables: {
                input: {
                    filters: {
                        userId: inputObj.userId,
                        worksheetId: inputObj.worksheetId
                    },
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * @purpose: start exam
     * @author: Arijit Deb Roy
     * @return:
     */
    startUserExam(courseId, examId, examType) {
        const START_USER_EXAM = gql`
			mutation SaveDiagnosticExam($token: AccessToken!,$input: DiagnosticExamSaveInput!){
			  SaveDiagnosticExam(token:$token,input:$input){
				code
				status
				message
				data{
				  examId
				  userExamId
				  totalTime
				  status
				  startTime
				}
			  }
			}`;
        return Client.mutate({
            mutation: START_USER_EXAM,
            variables: {
                input: {
                    courseId: courseId,
                    examId: examId,
                    examType: examType
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                }
            }
        });
    },

    /**
     * @purpose: save user answer
     * @author: Arijit Deb Roy
     * @return:
     */
    saveUserExamQuestion(userExamId, questionId, answer, timeTaken) {
        const SAVE_USER_EXAM_QUESTION = gql`
        mutation SaveDiagnosticQuestion($token: AccessToken!,$input: DiagnosticQuestionSaveInput!){
          SaveDiagnosticQuestion(token: $token,input: $input){
            code
            status
            message
          }
        }`;
        return Client.mutate({
            mutation: SAVE_USER_EXAM_QUESTION,
            variables: {
                input: {
                    userExamId: userExamId,
                    questionId: questionId,
                    answer: answer,
                    timetaken: timeTaken
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                }
            }
        });
    },

    /**
     * @purpose: save user exam
     * @author: Arijit Deb Roy
     * @return:
     */
    saveUserExam(userExamId, totalTimeTaken) {
        const SAVE_USER_EXAM = gql`
            mutation SubmitDiagnosticExam($token: AccessToken!,$input: DiagnosticExamSubmitInput!){
              SubmitDiagnosticExam(token: $token,input:$input){
                code
                status
                message
                data{
                  weeklyAttempt
                }
              }
            }`;
        return Client.mutate({
            mutation: SAVE_USER_EXAM,
            variables: {
                input: {
                    userExamId: userExamId,
                    totalTimeTaken: totalTimeTaken
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                }
            }
        });
    },

    /**
     * @purpose: start worksheet
     * @author: Arijit Deb Roy
     * @return:
     */
    startWorksheetExam(worksheetId) {
        const START_WORKSHEET_EXAM = gql`
          mutation SaveWorksheetExam($token: AccessToken!,$input: WorksheetExamSaveInput!){
            SaveWorksheetExam(token:$token,input:$input){
              code
              status
              message
              data{
                worksheetExamId
                userWorksheetExamId
                totalTime
                status
                startTime
              }
            }
          }`;
        return Client.mutate({
            mutation: START_WORKSHEET_EXAM,
            variables: {
                input: {
                    worksheetId: worksheetId,
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                }
            }
        });
    },

    /**
     * @purpose: save worksheet answer
     * @author: Arijit Deb Roy
     * @return:
     */
    saveWorksheetExamQuestion(userWorksheetExamId, worksheetQuestionId, worksheetAnswer, timeTaken) {
        const SAVE_WORKSHEET_EXAM_QUESTION = gql`
          mutation SaveWorksheetQuestion($token: AccessToken!,$input: WorksheetQuestionSaveInput!){
            SaveWorksheetQuestion(token: $token,input: $input){
              code
              status
              message
            }
          }`;
        return Client.mutate({
            mutation: SAVE_WORKSHEET_EXAM_QUESTION,
            variables: {
                input: {
                    userWorksheetExamId: userWorksheetExamId,
                    worksheetQuestionId: worksheetQuestionId,
                    worksheetAnswer: worksheetAnswer,
                    timetaken: timeTaken
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                }
            }
        });
    },

    /**
     * @purpose: save worksheet exam
     * @author: Arijit Deb Roy
     * @return:
     */
    saveWorksheetExam(userWorksheetExamId) {
        const SAVE_WORKSHEET_EXAM = gql`
          mutation SubmitWorksheetExam($token: AccessToken!,$input: WorksheetExamSubmitInput!){
            SubmitWorksheetExam(token: $token,input:$input){
              code
              status
              message
              data {
                lessonId
                topicId
              }
            }
          }`;
        return Client.mutate({
            mutation: SAVE_WORKSHEET_EXAM,
            variables: {
                input: {
                    userWorksheetExamId: userWorksheetExamId,
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                }
            }
        });
    },

    /**
     * @purpose: get course wise exam with instruction
     * @author: Arijit Deb Roy
     * @return:
     */
    detailsDashboardDiagnosticExam(userId, courseId) {
        const DASHBOARD_DIAGNOSTIC_EXAM_DETAILS = gql`query DetailsDashboardDiagnosticExam($token: AccessToken!, $input: DashboardDiagnosticExamInput!) {
              DetailsDashboardDiagnosticExam(token: $token, input: $input) {
                code
                status
                message
                data {
                  exams {
                    examId
                    courseId
                    instructionId
                    examTitle
                    examDescription
                    examType
                    examTotalQuestion
                    examTotalTime
                    examTotalCap
                    examPaid
                    examMinScore
                    examMaxScore
                    examStatus
                    examCreatedBy
                    examUpdatedBy
                    examCreatedAt
                    examUpdatedAt
                  }
                  incompleteExam {
                    createdAt
                    createdBy
                    updatedBy
                    updatedAt
                    examTitle
                    courseId
                    examId
                    userExamId
                    totalTime
                    remainingTime
                    questionAttempt
                    questionLeft
                    startTime
                    endTime
                    timeTaken
                  }
                  report{
                    examId
                    userExamId
                    userId
                    userExamTotalTime
                    userExamRemainingTime
                    userExamScore
                    userExamStatus
                    userExamCreatedBy
                    userExamUpdatedBy
                    userExamCreatedAt
                    userExamUpdatedAt
                  }
                }
              }
            }`;
        return Client.query({
            query: DASHBOARD_DIAGNOSTIC_EXAM_DETAILS,
            variables: {
                input: {
                    courseId: courseId,
                    userId: userId
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                }
            }
        });
    },

    /**
     * User Report Details
     * @author: Arijit Deb Roy
     * @params: userExamId: <Integer>, examType: <String>
     */
    fetchUserReportDetails(userExamId, examType) {
        const FETCH_USER_REPORT_DETAILS = gql`
              query fetchUserReportDetails($token: AccessToken!,$input: ReportDetailsInput!){
                fetchUserReportDetails(token: $token, input: $input){
                  code
                  status
                  message
                  data{
                    totalCount
                    questions{
                      userExamQuestionId
                      correctStatus
                      correctAns
                      userMockSectionId
                      sectionId
                      sectionName
                      mockSectionTimeId
                      sectionInstruction
                      sectionFileId
                      sectionTotalQuestion
                      sectionTotalDuration
                      sectionBreak
                      sectionWeight
                      sectionStatus
                      examQuestionId
                      questionId
                      examQuestionGroupId
                      examQuestionWeight
                      examQuestionStatus
                      questionTitle
                      questionType
                      questionLevel
                      subLevelFlag
                      subLevel
                      questionStatus
                      isNumeric
                      ansDescription
                      topicId
                      highlightPassageFlag
                      topicName
                      userExamId
                      answer
                      submitTime
                      remainingTime
                      timeTaken
                      questionOrder
                    }
                  }
                }
              }`;
        return Client.query({
            query: FETCH_USER_REPORT_DETAILS,
            variables: {
                input: {
                    userExamId: userExamId,
                    examType: examType
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole : 6,
                }
            }
        });
    },

    /**
     * @purpose: question details response
     * @author: Arijit Deb Roy
     * @return:
     */
    detailQuestion(courseId, questionId) {
        const DETAIL_QUESTION = gql`
                query detailQuestion($token: AccessToken!, $input: QuestionDetailsInput!) {
                  detailQuestion(token: $token, input: $input) {
                    code
                    status
                    message
                    data {
                      totalCount
                      question {
                        userAttemptedCount
                        details {
                          questionId
                          questionTitle
                          titleVisibility
                          questionLevel
                          questionType
                          questionFile
                          questionFilePath
                          isNumeric
                          correctAns
                          ansFile
                          ansFilePath
                          ansFileType
                          ansDescription
                          questionWeight
                          topicId
                          topicName
                          sectionId
                          sectionName
                          courseId
                          courseName
                          questionStatus
                          passageId
                          passageTitle
                          passage
                          passageFilePath
                          passageFileType
                          highlightPassage
                          highlightPassageFlag
                          usedInDrill
                          usedInWorksheet
                          usedInExam
                          authorFname
                          authorLname
                          authorEmail
                          authorFileId
                          authorFilePath
                          createdBy
                          createdAt
                          updatedBy
                          updatedAt
                        }
                        questionOptions {
                          questionOptionId
                          questionOption
                          questionOptionValue
                          questionOptionFile
                          questionOptionDescription
                          questionOptionFilePath
                          questionOptionFileType
                          questionOptionWeight
                          createdBy
                          createdAt
                          updatedBy
                          updatedAt
                        }
                        examRow {
                          examQuestionId
                          examId
                          examTitle
                          examType
                          courseId
                          paid
                          examStatus
                          weight
                          examQuestionStatus
                          createdBy
                          createdAt
                          updatedBy
                          updatedAt
                        }
                        worksheetRow {
                          lessonId
                          lessonName
                          pageId
                          worksheetQuestionId
                          worksheetId
                          worksheetName
                          pageContentType
                          worksheetStatus
                          weight
                          lessonStatus
                          worksheetQuestionStatus
                          createdBy
                          createdAt
                          updatedBy
                          updatedAt
                        }
                        drillRow {
                          lessonId
                          lessonName
                          pageId
                          drillQuestionId
                          drillId
                          drillName
                          pageContentType
                          drillStatus
                          weight
                          lessonStatus
                          drillQuestionStatus
                          createdBy
                          createdAt
                          updatedBy
                          updatedAt
                        }
                      }
                    }
                  }
                }
            `;
        return Client.query({
            query: DETAIL_QUESTION,
            variables: {
                input: {
                    courseId: courseId,
                    questionId: questionId,
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 1
                }
            }
        });
    },

    /**
     * @purpose: save mock question answer
     * @author: Arijit Deb Roy
     * @return:
     */
    mockAnswerSave(input) {
        const MOCK_EXAM_ANS_SAVE = gql`
            mutation MockQuestionSave($input: MockQuestionSaveInput!, $token: AccessToken!) {
              MockQuestionSave(input: $input, token: $token) {
                code
                status
                message
              }
            }
            `;
        return Client.mutate({
            mutation: MOCK_EXAM_ANS_SAVE,
            variables: {
                input: input,
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * @purpose: start mock exam
     * @author: Arijit Deb Roy
     * @return:
     */
    mockExamStart(input) {
        const MOCK_EXAM_START = gql`
            mutation MockExamStart($input: MockExamStartInput!, $token: AccessToken!) {
              MockExamStart(input: $input, token: $token) {
                code
                status
                message
                data {
                  userExamId
                  examId
                  userId
                  totalTime
                  startTime
                  status
                }
              }
            }
            `;
        return Client.mutate({
            mutation: MOCK_EXAM_START,
            variables: {
                input: input,
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * @purpose: start mock exam section
     * @author: Arijit Deb Roy
     * @return:
     */
    mockSectionStart(input) {
        const MOCK_SECTION_START = gql`
            mutation MockSectionStart($input: MockSectionStartInput!, $token: AccessToken!) {
              MockSectionStart(input: $input, token: $token) {
                code
                status
                message
                data {
                  userExamId
                  sectionTimeId
                  userMockSectionId
                  status
                }
              }
            }
            `;
        return Client.mutate({
            mutation: MOCK_SECTION_START,
            variables: {
                input: input,
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * @purpose: submit mock exam section
     * @author: Arijit Deb Roy
     * @return:
     */
    mockSectionSubmit(userExamId, userMockSectionId, usedSectionalTime) {
        const MOCK_SECTION_SUBMIT = gql`
            mutation MockSectionSubmit($input: MockSectionSubmitInput!, $token: AccessToken!) {
              MockSectionSubmit(input: $input, token: $token) {
                code
                status
                message
              }
            }
            `;
        return Client.mutate({
            mutation: MOCK_SECTION_SUBMIT,
            variables: {
                input: {
                    userExamId: userExamId,
                    userMockSectionId: userMockSectionId,
                    usedSectionalTime: usedSectionalTime
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * @purpose: submit mock exam
     * @author: Arijit Deb Roy
     * @return:
     */
    mockExamSubmit(userExamId) {
        const MOCK_EXAM_SUBMIT = gql`
            mutation MockExamSubmit($input: MockExamSubmitInput!, $token: AccessToken!) {
              MockExamSubmit(input: $input, token: $token) {
                code
                status
                message
              }
            }
            `;
        return Client.mutate({
            mutation: MOCK_EXAM_SUBMIT,
            variables: {
                input: {
                    userExamId: userExamId
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * @purpose: check if a particular diagnostic in resume state
     * @author: Arijit Deb Roy
     * @return:
     */
    diagnosticResumeCheck(input) {
        const DIAGNOSTIC_RESUME = gql`
            query diagnosticResumeCheck($input:  DiagnosticResumeCheckInput!, $token:  AccessToken!) {
              diagnosticResumeCheck(input: $input, token: $token) {
                status
                code
                message
                data {
                    examDetails{
                    examId
                    userExamId
                    totalTime
                    remainingTime
                    lastQuestionId
                    lastExamQuestionId
                    answer
                  }
                  examQuestionList{
                    userExamQuestionId
                    questionId
                    answer
                    timeTaken
                  }
                }
              }
            }
            `;
        return Client.query({
            query: DIAGNOSTIC_RESUME,
            variables: {
                input: input,
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * @purpose: check if a particular mock in resume state
     * @author: Arijit Deb Roy
     * @return:
     */
    mockResumeCheck(examId) {
        const MOCK_RESUME_CHECK = gql`
            query MockResumeCheck($input: MockResumeCheckInput!, $token:  AccessToken!) {
              MockResumeCheck(input: $input, token: $token) {
                status
                code
                message
                data {
                  userMockId
                  totalTime
                  remainingTime
                  startTime
                  status
                  lastUserMockSectionId
                  sectionRemainingTime
                  actualSectionRemainingTime
                  userMockSectionId
                  mockSectionKey
                  lastAttemptedQuestionId
                  lastMockSectionTimeId
                  lastMockSectionStatus
                  lastAttemptedUserMockQuestionId
                  examDetails{
                    examId
                    courseId
                    examTitle
                    examDescription
                    examType
                    totalQuestion
                    totalTime
                    totalBreakMin
                    totalCap
                    minScore
                    maxScore
                    examStatus
                    instructionId
                    instructionTitle
                    instruction
                  }
                  mockSectionList{
                    mockSectionTimeId
                    examId
                    sectionId
                    visibilityStatus
                    sectionName
                    sectionInstruction
                    sectionTotalQuestion
                    sectionTotalDuration
                    break
                    weight
                    status
                    fileName
                    filePath
                  }
                  questionList{
                    courseId
                    titleVisibility
                    questionFile
                    questionFilePath
                    passageFileType
                    ansFilePath
                    ansFile
                    ansFileType
                    ansDescription
                    questionStatus
                    passageId
                    userPassageId
                    userId
                    questionId
                    questionWeight
                    questionTitle
                    questionType
                    questionLevel
                    isNumeric
                    highlightPassageFlag
                    fileName
                    filePath
                    passageFileName
                    passageFilePath
                    passageTitle
                    passage
                    sectionId
                    topicId
                    userMockQuestionId
                    answer
                    correctAns
                    correctStatus
                    userMockSectionId
                    timeTaken
                    remainingTime
                    userHighlightPassage
                    highlightPassageId
                    highlightPassage
                    questionOptions{
                      questionId
                      questionOptionId
                      questionOption
                      questionOptionValue
                      questionOptionFile
                      questionOptionFilePath
                      questionOptionWeight
                      questionOptionFileType
                      questionOptionDescription
                    }
                  }
                }
              }
            }
            `;
        return Client.query({
            query: MOCK_RESUME_CHECK,
            variables: {
                input: {
                    examId: examId
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * @purpose: get all mock exams in initiate state
     * @author: Arijit Deb Roy
     * @return:
     */
    resumeMockExamList(userId, courseId) {
        const RESUME_MOCK_EXAM_LIST = gql`
                query ResumeMockExamList($token: AccessToken!, $input: ResumeMockExamListInput!) {
                  ResumeMockExamList(token: $token, input: $input) {
                    code
                    status
                    message
                    data {
                      examList{
                        userMockId
                        userId
                        examId
                        totalTime
                        remainingTime
                        questionAttempt
                        questionLeft
                        startTime
                        endTime
                        status
                        createdBy
                        examTitle
                        examDescription
                        examType
                        createdAt
                      }
                      totalCount
                    }
                  }
                }
            `;
        return Client.query({
            query: RESUME_MOCK_EXAM_LIST,
            variables: {
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                },
                input: {
                    userId: userId,
                    courseId: courseId,
                }
            }
        });
    },

    /**
     * @purpose: check user expertise
     * @author: Arijit Deb Roy
     * @return:
     */
    checkUserExpertise(input) {
        const CHECK_USER_EXPERTISE = gql`
            query checkUserExpertise($token: AccessToken!,$input: CheckUserExpertiseInput!){
              checkUserExpertise(token: $token,input:$input){
                code
                status
                message
                data {
                  expertiseLevel
                }
              }
            }`;
        return Client.query({
            query: CHECK_USER_EXPERTISE,
            variables: {
                input: input,
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * question detail response
     * @author: Arijit Deb Roy
     * @params: token: <accessToken>, inputObj: <JSON> {"userId":1,"userExamId":356,"examType":"full_mock","questionIds":[302,304]}
     */
    examQuestionDetails(inputObj) {
        const EXAM_QUESTIONS = gql`
                query examQuesFetch($token:  AccessToken!, $filters: MockSectionQuesInput!) {
                  examQuesFetch(token: $token, filters: $filters) {
                    code
                    status
                    message
                    data {
                      questions {
                        questionId
                        questionType
                        questionFile
                        questionTitle
                        questionFilePath
                        questionLevel
                        questionStatus
                        titleVisibility
                        courseId
                        sectionId
                        topicId
                        sectionName
                        topicName
                        isNumeric
                        correctAns
                        ansFile
                        ansFilePath
                        ansFileType
                        ansDescription
                        passage
                        passageFilePath
                        passageFileType
                        highlightPassage
                        highlightPassageId
                        highlightPassageFlag
                        userHighlightPassage
                        questionOptions {
                          questionOptionId
                          questionOptionFile
                          questionOptionValue
                          questionOptionFilePath
                          questionOptionFileType
                          questionOptionWeight
                          questionOption
                        }
                      }
                      totalCount
                    }
                  }
                }
            `;
        return Client.query({
            query: EXAM_QUESTIONS,
            variables: {
                filters: inputObj,
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                }
            }
        });
    },

    /**
     * User mock mail Details
     * @author: Arijit Deb Roy
     * @params: userExamId: <Integer>
     */
    mockMailDetails(userExamId) {
        const FETCH_USER_MOCK_MAIL_DETAILS = gql`
        query mockMailDetails($token: AccessToken!, $input: MockMailDetailsInput!) {
          mockMailDetails(token: $token, input: $input) {
            code
            status
            message
            data {
              userExamId
              mockScore
              previousMockScore
              mockTime
              previousMockTime
              updatedPredictiveScore
            }
          }
        }
        `;
        return Client.query({
            query: FETCH_USER_MOCK_MAIL_DETAILS,
            variables: {
                input: {
                    userExamId: userExamId,
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole : 6,
                }
            }
        });
    },
}

export default ExamAction;
